import React from "react";

import type { TextListItemBlock } from "@reactivated";

import { ButtonPrimary } from "../Clickables";

import styles from "./TextListItem.module.scss";

export const TextListItem = ({ value }: { value: TextListItemBlock }) => {
    const url = value.link?.url;
    if (!url) return null;

    return (
        <li className={styles.item}>
            <div className={styles.content}>
                <a href={url} className={styles.title}>
                    {value.title}
                </a>
                {value.eyebrow && (
                    <span className={styles.eyebrow}>{value.eyebrow}</span>
                )}
            </div>
            <ButtonPrimary
                simpleLink={value.link ?? undefined}
                className={styles.button}
            />
        </li>
    );
};
